/* eslint-disable eqeqeq */
// components/Counter.tsx
/* eslint-disable react-hooks/exhaustive-deps */

import { useDispatch, useSelector } from "react-redux";
import "./PackageSlotsNew.scss";
import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useTranslation, withTranslation } from "react-i18next";
import { actionCreators } from "../../../../store";
import { RootState } from "../../../../store/reducers";
import { apiService } from "../../../../services";
import { getDateForDayOfWeek } from "../../../../helper/dates";
import { get_lang } from "../../../../helper/getLang";
import BasicDatePicker from "../../../../components/dataPicker/DatePicker";
import FreezScreen from "../../../../components/FreezScreen";
import { convertTo12HourFormat } from "../../../../utils/genral-functions";
import NewNextBtn from "../../../../components/BtnNext/NewNextBtn";
import { getLang } from "../../../../helper/global";
import BookingStepSection from "./BookingStepSection";
import SelectionChipGrid from "./SelectionChipGrid";

const PackageSlotsNew = (props: any) => {
  const { slotsList, times, apiLoading, setGetSeletedDateByUSer, excludedDates, maxDays=0 } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setBookingForm, alertMessageState, setCart } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const state = useSelector((state: RootState) => state.appReducer);
  const { langValue, bookingForm } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const { bookingDetails } = appState;
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [bId, setBId] = useState(searchParams.get("bId"));
  const [oldBid, setOldBid]: any = useState("");
  const { slug } = useParams();
  const [routeLoading, setRouteLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [subTotalGuest, setSubTotalGuest] = useState([]);
  const [timeValue, settimeValue] = useState(-1);
  // const [apiLoading, setApiLoading] = useState(false);
  const [selectionType, setSelectionType] = useState(1);
  const [startAt, setStartAt]: any = useState("");
  const [endAt, setEndAt]: any = useState("");
  const [days, setDays] = useState([]);
  const [slots, setSlots] = useState([]);
  const [guest, setGuest] = useState([
    {
      id: `1_id`,
      name: `1 Guest`,
      value: 1,
    },
  ]);
  const [packages, setPackages] = useState([]);
  const [hasExtras, sethHsExtras] = useState(false);
  const [formFields, setFormFields]: any = useState({
    packageId: 0,
    packageName: null,
    bookingTime: null,
    bookingDayObj: null,
    bookingDate: null,
    checkBoxDate: null,
    currentSelectedDate: null,
    validDate: true,
  });
  const [initalMount, setInitalMount] = useState(true);
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
  const [selectDateCheckBox, setSelectDateCheckBox] = React.useState<
    Date | any
  >([]);

  // Function to handle date change
  const handleDateChange = (date: Date | null | any, validDate: boolean = true) => {
    console.log(date, 'handleDatechange')

    let moment = require("moment");
    let dateFormat = new Date(date);
    let selectedDayOfWeek: any;
    let newGuest: any = [];
    // Set initial min and max values
    let min: number = 1;
    let max: number = 1;
    // Format the date as "3/10/2024"
    // Format the date as "29-03-2024"
    const formattedDate = moment(dateFormat).format("YYYY-MM-DD");
    // Get the day of the month
    const selectedDayOfMonth = dateFormat.getDate(); // Example: 10
    // Update min and max based on the current guest state
    if (guest.length > 0) {
      min = guest[0].value;
      max = guest[guest.length - 1].value;
    }

    setSelectedDate(date);
    if (dateFormat) {
      const options: any = { weekday: "long" };
      selectedDayOfWeek = dateFormat.toLocaleString("en-US", options); // Day of the week as a string (e.g., "Monday", "Tuesday", etc.)
    }
    if (selectionType === 1) {
      let findDay: any = days.find(
        (item: any) => item.day === selectedDayOfWeek
      );
      setFormFields({
        ...formFields,
        bookingDayObj: findDay,
        bookingDate: formattedDate,
        checkBoxDate: date,
        currentSelectedDate: date,
        validDate: validDate,
      });
      console.log("setGetSeletedDateByUSer", date);
      setGetSeletedDateByUSer(date);
    } else if (selectionType === 2) {
      let findDay: any = days.find(
        (item: any) => item.day === selectedDayOfWeek
      );
      if (findDay) {
        setFormFields({
          ...formFields,
          bookingDayObj: findDay,
          bookingDate: formattedDate,
          checkBoxDate: date,
          currentSelectedDate: date,
          validDate: validDate,
        });
        setGetSeletedDateByUSer(date);
      }
    } else if (selectionType === 3) {
      // Handle selection type 3
      let findDay: any = days.find(
        (item: any) => item.day == selectedDayOfMonth
      );

      if (findDay) {
        // Update max if maxGuest is less than the current max
        setFormFields({
          ...formFields,
          bookingDayObj: findDay,
          bookingDate: formattedDate,
          checkBoxDate: date,
          currentSelectedDate: date,
          validDate: validDate,
        });
        setGetSeletedDateByUSer(date);
      } else {
        setFormFields({
          ...formFields,
          bookingDayObj: findDay,
          bookingDate: formattedDate,
          validDate: validDate,
        });
      }
    }
  };
console.log(times)
  const handleDiscount = (discount: any, price: any) => {
    let discountAmount: any = discount?.amount ?? 0;
    let actualAmount: any = Number(price) - Number(discountAmount);
    return Number(actualAmount);
  };
  const handleNext = () => {
    let form: any = { ...formFields };
    setRouteLoading(true);
    let bookingCategory = bookingDetails.find(
      (item: any) => item.id == Number(bId)
    );
    slots.forEach((ele: any) => {
      console.log(ele);
      let timeId: any = ele?.time?.id;
      let bookedTime: any = form?.bookingTime?.id;
      let bookedDayId: any = form?.bookingDayObj?.id ?? null;
      let dayId: any = ele?.day?.id ?? null;
      let slotPrice: any = form?.pkgPrice;
      if (selectionType == 1) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
          bookingDayObj: null,
        };
      } else if (selectionType == 2) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
        };
      } else if (selectionType == 3) {
        form = {
          ...form,
          slotPrice: slotPrice,
          slotId: ele?.id,
          hasGuestPricing: ele?.has_guest_pricing,
          bookingType: selectionType,
          bookingPrice: bookingCategory?.price,
        };
      }
    });
    if (!form.validDate) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang({en: "Please select a valid date", ar: "يرجى تحديد تاريخ صالح."}, langValue),
      });
      return;
    }
    if (form.packageName == null) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang(
          { en: "Please select a packege", ar: "يرجى اختيار الباقة" },
          langValue
        ),
      });
    } else if (form.bookingDate === null) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang(
          { en: "Please select a booking date", ar: "يرجى تحديد تاريخ الحجز" },
          langValue
        ),
      });
    } else if (form.bookingTime === null) {
      alertMessageState({
        type: "error",
        show: true,
        message: getLang(
          { en: "Please select a booking time", ar: "يرجى تحديد وقت الحجز." },
          langValue
        ),
      });
    } else {
      setBookingForm({
        ...form,
        bookingCategory: bookingCategory,
        b_id: Number(bId),
        slotsType: bookingCategory?.slotsType,
      });
      if (bookingCategory?.hasExtras) {
        navigate(`/${slug}/step-2?bId=${bId}`);
      } else {
        setCart([]);
        navigate(`/${slug}/step3?bId=${bId}`);
      }
    }
  };

  const handleClickPackage = (id: any) => {
    let formData: any = { ...formFields };

    if (formData.packageId == id) {
      formData = { ...formData, packageId: null, PkgName: null , packageName: null};
    } else {
      let findPkg: any = packages.find((item: any) => item.id == id);
      formData = {
        ...formData,
        packageId: id,
        packageName: findPkg?.pkgName,
        pkgPrice: findPkg?.price,
        pkgDiscount: findPkg?.discount,
      };
    }

    setFormFields(formData);
  };

  const handleTimeChange = (id: any) => {
    // Use the current guest state directly
    let formData: any = { ...formFields };

    // Find the corresponding time data based on id
    let filterTime: {} | any = times.find((item: any) => item.id == id);

    if (timeValue == id) {
      settimeValue(-1);
      // Update guest state
      formData = {
        ...formData,
        NoGuest: null,
        bookingTime: null,
        bookingTimeInd: -1,
      };

      setGuest(subTotalGuest);
    } else {
      settimeValue(id);
      // Check if filterTime exists
      formData = { ...formData, bookingTime: filterTime, bookingTimeInd: id };
    }

    setFormFields(formData);
  };

  useEffect(() => {
    if (appState.storeList) {
      let foundSlot = slotsList.find((item: any) => item?.b_id == bId);
      if (foundSlot) {
        handleCurrentSlot(foundSlot);
      }
    }
  }, [appState?.storeList]);

  const handleCurrentSlot = (data: any) => {
    let slotRes: any = [];
    slotRes.push(data?.slots);
    if (data) {
      let bookingCategory = bookingDetails.find((item: any) => item?.id == bId);
      if (bookingCategory?.typeId) {
        setSelectionType(bookingCategory?.typeId);
        setStartAt(bookingCategory?.startAt ?? "");
        setEndAt(bookingCategory?.endAt ?? "");
      }
      setSlots(slotRes);
      let dayArr: any = [];
      let timeArr: any = [];
      let pkgArr: any = [];
      let countPkgId: number = 1;
      slotRes.forEach((ele: any) => {
        if (ele?.active) {
          ele?.days.forEach((day: any) => {
            if (dayArr.length > 0) {
              if (
                !dayArr.some((checkEle: any) => checkEle?.id == ele?.day?.id)
              ) {
                dayArr.push({
                  ...day,
                  type: bookingCategory?.typeId,
                  startAt: bookingCategory?.startAt,
                  endAt: bookingCategory?.endAt,
                });
              }
            } else {
              dayArr.push({
                ...day,
                type: bookingCategory?.typeId,
                startAt: bookingCategory?.startAt,
                endAt: bookingCategory?.endAt,
              });
            }
          });
        }
      });

      setDays(dayArr);
    }
  };
  const getPkgs = async (id: any) => {
    let res = await apiService.getPackeges(id);
    let pkgArr: any = [];
    if (res?.data?.success) {
      res?.data?.data.forEach((ele: any) => {
        console.log(ele);
        if (ele?.active) {
          pkgArr.push({
            active: ele?.active,
            id: ele?.id,
            pkgName: ele?.name,
            price: ele?.price | 0,
            discount: ele?.discount | 0,
          });
        }
      });
      setPackages(pkgArr);
    }
  };
  useEffect(() => {
    if (bookingDetails.length > 0) {
      if (bId) {
        if (slotsList) {
          let foundSlot = slotsList.find((item: any) => item?.b_id == bId);
          if (foundSlot) {
            handleCurrentSlot(foundSlot);
          } else {
            // getSlots(Number(bId));
          }
        } else {
          // getSlots(Number(bId));
        }
        setFormFields({
          NoGuest: null,
          packageId: 0,
          packageName: null,
          bookingTime: null,
          bookingDayObj: null,
          bookingDate: null,
        });
        setSelectedDate(null);
        let findIndex = bookingDetails.findIndex(
          (item: any) => item.id == Number(bId)
        );
        sethHsExtras(bookingDetails[findIndex]?.hasExtras);
        setValue(Number(findIndex));
      } else {
        // getSlots(bookingDetails[0].id);
      }
    }

    if (bId != searchParams.get("bId")) {
      getPkgs(bId);
    }

    // getPkgs(bId)

    if (bookingForm?.bookingTime) {
      if (bookingForm?.b_id == bId) {
        getPkgs(bookingForm?.b_id);
        settimeValue(bookingForm.bookingTimeInd);
        setFormFields({
          NoGuest: null,
          packageId: bookingForm?.packageId,
          PkgName: bookingForm?.PkgName,
          bookingTime: bookingForm?.bookingTime,
          bookingTimeInd: bookingForm?.bookingTimeInd,
          bookingDayObj: bookingForm?.bookingDayObj,
          bookingDate: bookingForm?.bookingDate,
          checkBoxDate: bookingForm?.checkBoxDate,
          packageName: bookingForm?.packageName,
          currentSelectedDate: dayjs(bookingForm?.currentSelectedDate),
          b_id: bookingForm.b_id,
        });
        setGetSeletedDateByUSer(dayjs(bookingForm?.currentSelectedDate));
      }
    }
  }, [bId, slotsList]);

  useEffect(() => {
    let { NoGuest, packageId, bookingTime, bookingDate } = formFields;
    let dayArr: any = [];
    let timeArr: any = [];
    let min: number = 0;
    let max: number = 1;

    if (initalMount) {
      setInitalMount(false);
    } else {
      if (packageId > 0 && bookingTime == null) {
        let findTime = times?.find((item: any) =>
          item?.pkgId?.includes(packageId)
        );
      }
    }
  }, [formFields?.packageId, formFields.bookingTime, formFields?.bookingDate]);

  useEffect(() => {
    setBId(searchParams.get("bId"));
  }, [searchParams]);

  useEffect(() => {
    if (bId != oldBid) {
      getPkgs(bId);
      setOldBid(bId);
    }
  }, [bId]);
  const isRtl = langValue === "ar";

  const packageChipOptions = packages?.map((item: any) => ({
    id: item.id,
    label: get_lang(item.pkgName, langValue),
  }));

  const timeChipOptions = times
    ?.filter((item: any) => item.available_time)
    .map((item: any) => ({
      id: item.id,
      label:
        slug === "kul-kuwait-city"
          ? convertTo12HourFormat(item?.starting)
          : `${convertTo12HourFormat(item?.starting)} - ${convertTo12HourFormat(item?.ending)}`,
      disabled:
        formFields?.NoGuest > item.maxGuest ||
        !item?.has_space ||
        !item?.available_time,
    }));

  return (
    <React.Fragment>
      <div id="package-slots-new">
      {routeLoading && <FreezScreen />}

      {apiLoading ? (
        <div className="py-2 px-2">
          <div className="col-md-12 px-0">
            <Skeleton height={100} />
          </div>
          <div className="col-md-12 px-0">
            <Skeleton height={100} />
          </div>
        </div>
      ) : (
        <BookingStepSection
          step={1}
          title={t("custom-msg.Select-Date")}
          icon="📅"
          rtl={isRtl}
        >
          <BasicDatePicker
            type={selectionType}
            start_At={startAt}
            end_At={endAt}
            data={days}
            label={`${t("custom-msg.Select-Date")}`}
            selectedDate={formFields?.currentSelectedDate ?? null}
            handleDateChange={handleDateChange}
            reservation={formFields}
            langValue={langValue}
            excludedDates={excludedDates}
            maxDays={maxDays}
          />
        </BookingStepSection>
      )}

      {apiLoading ? (
        <div className="py-3 px-2">
          <Skeleton height={30} width={140} />
          <Skeleton height={50} className="mt-2" />
        </div>
      ) : (
        <BookingStepSection
          step={2}
          title={t("custom-msg.Select Package")}
          icon="📦"
          rtl={isRtl}
        >
          <SelectionChipGrid
            options={packageChipOptions}
            selectedId={formFields?.packageId || null}
            onSelect={handleClickPackage}
            rtl={isRtl}
          />
        </BookingStepSection>
      )}

      {apiLoading
        ? ""
        : times?.length > 0 && (
            <BookingStepSection
              step={3}
              title={t("custom-msg.Arrival-time")}
              icon="🕐"
              rtl={isRtl}
              className="mb-5 pb-3"
            >
              <SelectionChipGrid
                options={timeChipOptions}
                selectedId={timeValue !== -1 ? timeValue : null}
                onSelect={handleTimeChange}
                rtl={isRtl}
              />
            </BookingStepSection>
          )}

      <NewNextBtn
        label={`${t("custom-msg.Next")} `}
        handleCheckout={handleNext}
        disBtn={apiLoading}
      />

      {/* <BtnNext label="Next" handleCheckout={handleNext} /> */}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(PackageSlotsNew);
